import React from 'react';
import { observer } from 'mobx-react';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import { action, extendObservable } from 'mobx';
import * as validate from '../../../../helpers/formValidation';

import store from '../../../../stores/store';
import {
    MANDATORY_FIELD,
    FIELD_ERROR_CLASS,
    FIELD_STANDARD_CLASS,
    FIELD_LENGTH,
    EMAIL_INVALID_MSG,
    ALPHANUMERICSPACE_ONLY,
} from '../../../../helpers/messageText';

const ProfileEdit = observer(
    class ProfileEdit extends React.Component {
        constructor() {
            super();

            const profileList = store.user.profile || [];
            const userData = profileList[store.user.selectedIndex];

            this.state = {
                file: '',
                imagePreviewUrl: null,
                canLoad: true,
            };

            this.form = extendObservable(this, {
                errFirstnameText: '',
                errSurnameText: '',
                errTitleText: '',
                errPhone1Text: '',
                errPhone2Text: '',
                errEmailAddressText: '',
                errAddress1Text: '',
                errAddress2Text: '',
                errSuburbText: '',
                errStateText: '',
                errPostcodeText: '',
                errCountryText: '',

                errAvatarText: '',

                canSubmit: false,

                Firstname: store.user.data.FirstName,
                Surname: store.user.data.Surname,
                Title: userData.Title,
                Phone1: userData.Phone1,
                Phone2: userData.Phone2,
                EmailAddress: userData.EmailAddress,
                Address1: userData.Address1,
                Address2: userData.Address2,
                Suburb: userData.Suburb,
                State: userData.State,
                Postcode: userData.PostCode,
                Country: userData.Country,

                AvatarImage: store.user.localAvatarUrl,

                error: 0,
                pending: false,

                set: action((field, value) => {
                    this[field] = value;
                }),
                get canSubmitForm() {
                    return this.canSubmit;
                },
            });
        }

        _handleImageChange = e => {
            e.preventDefault();

            let reader = new FileReader();
            let file = e.target.files[0];

            var ext = file.type.toLowerCase();

            this.form.set('errAvatarText', '');
            this.form.set('canSubmit', true);

            switch (ext) {
                case 'image/jpg':
                case 'image/JPG':
                case 'image/jpeg':
                case 'image/png':
                    // DO some error validation
                    if (file.size > 10000000) {
                        this.form.set(
                            'errAvatarText',
                            'The file being uploaded cannot exceed 10mb.',
                        );
                        this.form.set('canSubmit', false);
                        this.form.set('imagePreviewUrl', null);
                    } else {
                        var img = document.createElement('img');
                        var blob = URL.createObjectURL(file);
                        img.src = blob;

                        img.onload = e => {
                            if (
                                img.height < 50 ||
                                img.width < 50 ||
                                img.height > 400 ||
                                img.width > 400
                            ) {
                                this.form.set(
                                    'errAvatarText',
                                    'Image size: Minimum - 50 x 50 px; Maximum - 400 x 400 px.',
                                );

                                this.form.set('canSubmit', false);
                                this.form.set('imagePreviewUrl', null);
                            }
                        };
                    }

                    break;

                default:
                    this.form.set('errAvatarText', 'Logo must be an image only (.jpg .png .jpeg)');
                    this.form.set('canSubmit', false);
            }

            if (this.form.canSubmitForm) {
                this.form.set('file', file);

                this.form.set('canSubmit', true);

                reader.onloadend = e => {
                    this.setState({
                        file: file,
                        imagePreviewUrl: reader.result,
                    });
                };
                reader.readAsDataURL(file);
            }
        };

        handleSubmit = event => {           
            event.preventDefault();
            //prevent extra clicks
            this.form.set('canSubmit', false);

            const profileList = store.user.profile || [];

            //This is maintaining shared data for the right profile
            let profileSwitchData = store.user.profileSwitchData[store.user.currentProfile].split(',');
            let phone1Switch = profileSwitchData[0] === "1" ? true : false;
            let phone2Switch = profileSwitchData[1] === "1" ? true : false;
            let shareEmailAddress = profileSwitchData[2] === "1" ? true : false;

            const userProfile = {
                instanceid: profileList[store.user.selectedIndex].InstanceId,
                firstname: this.Firstname,
                surname: this.Surname,
                title: this.Title,
                phone1: this.Phone1,
                phone2: this.Phone2,
                emailaddress: this.EmailAddress,
                address1: this.Address1,
                address2: this.Address2,
                suburb: this.Suburb,
                state: this.State,
                postcode: this.Postcode,
                country: this.Country,
                shouldSharePhone1: phone1Switch,
                shouldSharePhone2: phone2Switch,
                shouldShareEmailAddress: shareEmailAddress
            };

            this.form.set('pending', true);

            if (this.file !== undefined) {
                store.user
                    .updateAvatar(this.file)
                    .then(json => {
                        this.form.set('pending', false);
                        store.user.profileToEdit(0);
                        this.props.history.push('profile');
                    })
                    .catch(e => {
                        this.form.set('pending', false);

                        if (
                            e !== undefined &&
                            e.spread !== undefined &&
                            e.spread.Details !== undefined &&
                            e.spread.Details.Error !== undefined
                        ) {
                            this.form.set('error', e.spread.Details.Error);
                        } else {
                            this.form.set('error', 'Error');
                        }
                    });
            }

            // We update the profile
            store.user
                .updateProfile(userProfile)
                .then(json => {
                    this.form.set('pending', false);
                    store.user.profileToEdit(0);
                    this.props.history.push('profile');
                })
                .catch(e => {
                    this.form.set('pending', false);

                    if (
                        e !== undefined &&
                        e.spread !== undefined &&
                        e.spread.Details !== undefined &&
                        e.spread.Details.Error !== undefined
                    ) {
                        this.form.set('error', e.spread.Details.Error);
                    } else {
                        this.form.set('error', 'Error');
                    }
                });

            this.form.set('pending', false);
            var switchData = [];
            store.user.set("profileSwitchData", switchData);
        };

        clickUpload = e => {
            var inputField = this.refs.fileField;
            inputField.click();
        };

        cancelEdit = () => {
            var profileSwitchData = [];
            store.user.set("profileSwitchData", profileSwitchData);
            store.user.profileToEdit(0);
            this.props.history.push('/profile');
        };

        handleChange = e => {
            switch (e.target.name) {
                case 'Firstname':
                    // Firstname validation
                    let errFirstnameText = '';

                    if (validate.required(e.target.value)) {
                        errFirstnameText = MANDATORY_FIELD.split('[FIELDNAME]').join(
                            e.target.dataset.fieldName,
                        );
                    }

                    if (validate.length(e.target.value, 0, 50)) {
                        errFirstnameText = FIELD_LENGTH.split('[FIELDNAME]')
                            .join(e.target.dataset.fieldName)
                            .split('[FIELDLENGTH]')
                            .join('50');
                    }

                    this.form.set('canSubmit', errFirstnameText !== '' ? false : true);

                    this.form.set('errFirstnameText', errFirstnameText);
                    this.form.set('Firstname', e.target.value);
                    break;

                case 'Surname':
                    // Surname validation
                    let errSurnameText = '';

                    if (validate.required(e.target.value)) {
                        errSurnameText = MANDATORY_FIELD.split('[FIELDNAME]').join(
                            e.target.dataset.fieldName,
                        );
                    }

                    if (validate.length(e.target.value, 0, 50)) {
                        errSurnameText = FIELD_LENGTH.split('[FIELDNAME]')
                            .join(e.target.dataset.fieldName)
                            .split('[FIELDLENGTH]')
                            .join('50');
                    }

                    this.form.set('canSubmit', errSurnameText !== '' ? false : true);
                    this.form.set('errSurnameText', errSurnameText);
                    this.form.set('Surname', e.target.value);
                    break;

                case 'Title':
                    // Title validation
                    let errTitleText = '';

                    if (validate.required(e.target.value)) {
                        errTitleText = MANDATORY_FIELD.split('[FIELDNAME]').join(
                            e.target.dataset.fieldName,
                        );
                    }

                    this.form.set('canSubmit', errTitleText !== '' ? false : true);
                    this.form.set('errTitleText', errTitleText);
                    this.form.set('Title', e.target.value);
                    break;
                case 'Phone1':
                    // Phone validation
                    let errPhone1Text = '';

                    if (validate.required(e.target.value)) {
                        errPhone1Text = MANDATORY_FIELD.split('[FIELDNAME]').join(
                            e.target.dataset.fieldName,
                        );
                    }

                    this.form.set('canSubmit', errPhone1Text !== '' ? false : true);
                    this.form.set('errPhone1Text', errPhone1Text);
                    this.form.set('Phone1', e.target.value);
                    break;

                case 'EmailAddress':
                    // Email validation
                    let errEmailAddressText = '';

                    if (validate.required(e.target.value)) {
                        errEmailAddressText = MANDATORY_FIELD.split('[FIELDNAME]').join(
                            e.target.dataset.fieldName,
                        );
                    }

                    if (validate.emailAddress(e.target.value)) {
                        errEmailAddressText = EMAIL_INVALID_MSG;
                    }

                    this.form.set('canSubmit', errEmailAddressText !== '' ? false : true);

                    this.form.set('errEmailAddressText', errEmailAddressText);
                    this.form.set('EmailAddress', e.target.value);
                    break;
                case 'Address1':
                    // Email validation
                    let errAddress1Text = '';

                    this.form.set('canSubmit', errAddress1Text !== '' ? false : true);

                    this.form.set('errAddress1Text', errAddress1Text);
                    this.form.set('Address1', e.target.value);
                    break;
                case 'Phone2':
                    this.form.set('Phone2', e.target.value);
                    this.form.set('canSubmit', true);
                    break;
                case 'Address2':
                    this.form.set('Address2', e.target.value);
                    this.form.set('canSubmit', true);
                    break;
                case 'Suburb':
                    // Email validation
                    let errSuburbText = '';

                    if (e.target.value)
                    {
                    if (validate.alphanumericWithSpaces(e.target.value)) {
                        errSuburbText = ALPHANUMERICSPACE_ONLY;
                    }
                    }

                    this.form.set('canSubmit', errSuburbText !== '' ? false : true);

                    this.form.set('errSuburbText', errSuburbText);
                    this.form.set('Suburb', e.target.value);
                    break;
                case 'State':
                    // State validation
                    let errStateText = '';

                    if (validate.required(e.target.value)) {
                        errStateText = MANDATORY_FIELD.split('[FIELDNAME]').join(
                            e.target.dataset.fieldName,
                        );
                    }

                    this.form.set('canSubmit', errStateText !== '' ? false : true);
                    this.form.set('errStateText', errStateText);
                    this.form.set('State', e.target.value);
                    break;
                case 'Postcode':
                    // Postcode validation
                    let errPostcodeText = '';

                    if (e.target.value)
                    {
                    if (validate.alphanumericWithSpaces(e.target.value)) {
                        errPostcodeText = ALPHANUMERICSPACE_ONLY;
                    }
                }

                    this.form.set('canSubmit', errPostcodeText !== '' ? false : true);
                    this.form.set('errPostcodeText', errPostcodeText);
                    this.form.set('Postcode', e.target.value);
                    break;
                case 'Country':
                    // Country validation
                    let errCountryText = '';

                    if (validate.required(e.target.value)) {
                        errCountryText = MANDATORY_FIELD.split('[FIELDNAME]').join(
                            e.target.dataset.fieldName,
                        );
                    }

                    this.form.set('canSubmit', errCountryText !== '' ? false : true);
                    this.form.set('errCountryText', errCountryText);
                    this.form.set('Country', e.target.value);

                    break;

                default:
                    break;
            }
        };

        render() {
            // We get the current selecte user profile

            const profileList = store.user.profile || [];
            const userData = profileList[store.user.selectedIndex];

            let { imagePreviewUrl } = this.state;
            let $imagePreview = null;
            if (imagePreviewUrl) {
                $imagePreview = imagePreviewUrl;
            } else {
                $imagePreview = store.user.localAvatarUrl;
            }

            return (
                <div>
                    <form id="edit-user-profile" onSubmit={this.handleSubmit}>
                        <div className="card-block pb-0 col-12 text-center">
                            <img
                                src={$imagePreview}
                                className="user-pic-profile mx-auto img-fluid rounded-circle"
                                alt="avatar"
                            />
                            <div className="file-upload col-12 mt-3">
                                <label
                                    className="file-upload__label"
                                    onClick={() => {
                                        this.clickUpload();
                                    }}
                                >
                                    <i className="fa fa-upload pr-2" aria-hidden="true" />Upload
                                    photo
                                </label>
                                <input
                                    className="file-upload__input"
                                    aria-hidden="true"
                                    type="file"
                                    name="AvatarImage"
                                    ref="fileField"
                                    onChange={e => this._handleImageChange(e)}
                                />
                            </div>

                            {this.errAvatarText !== '' && (
                                <div className="small form-control-feedback font-danger">
                                    {this.errAvatarText}
                                </div>
                            )}
                        </div>
                        <div className="p-2">
                            <table className="table table-sm d-flex justify-content-center">
                                <tbody>
                                    <tr>
                                        <th scope="row">First name</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errFirstnameText ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Firstname"
                                                    data-field-name="first name"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={store.user.data.FirstName}
                                                />
                                                {this.errFirstnameText !== '' && (
                                                    <div className="form-group row has-danger small form-control-feedback">
                                                        {this.errFirstnameText}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Surname</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errSurnameText ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Surname"
                                                    data-field-name="last name"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={store.user.data.Surname}
                                                />

                                                {this.errSurnameText !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errSurnameText}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Company</th>
                                        <td className="pl-3">
                                            <div>
                                                <div className="d-flex justify-content-start">
                                                    {userData.Company}
                                                    <div className="ml-auto mt-auto p-0">
                                                        <i
                                                            className="fa fa-lock pr-2"
                                                            aria-hidden="true"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Title</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errTitleText ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Title"
                                                    data-field-name="title"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.Title}
                                                />
                                                {this.errTitleText !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errTitleText}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Phone</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errPhone1Text ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Phone1"
                                                    data-field-name="phone"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.Phone1}
                                                />

                                                {this.errPhone1Text !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errPhone1Text}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Mobile</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errPhone2Text ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Phone2"
                                                    data-field-name="mobile"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.Phone2}
                                                />
                                                {this.errPhone2Text !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errPhone2Text}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Email</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errEmailAddressText ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="EmailAddress"
                                                    data-field-name="email address"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.EmailAddress}
                                                />
                                                {this.errEmailAddressText !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errEmailAddressText}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Address</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errAddress1Text ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Address1"
                                                    data-field-name="address"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.Address1}
                                                />

                                                {this.errAddress1Text !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errPhone2Text}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row" />
                                        <td>
                                            <div
                                                className={
                                                    this.errAddress2Text ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Address2"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.Address2}
                                                />
                                                {this.errAddress2Text !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errPhone2Text}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">City</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errSuburbText ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Suburb"
                                                    data-field-name="city"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.Suburb}
                                                />
                                                {this.errSuburbText !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errSuburbText}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">State</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errStateText ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="State"
                                                    data-field-name="state"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.State}
                                                />
                                                {this.errStateText !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errStateText}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Post code</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errPostcodeText ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Postcode"
                                                    data-field-name="post code"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.PostCode}
                                                />
                                                {this.errPostcodeText !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errPostcodeText}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Country</th>
                                        <td>
                                            <div
                                                className={
                                                    this.errCountryText ? (
                                                        FIELD_ERROR_CLASS
                                                    ) : (
                                                        FIELD_STANDARD_CLASS
                                                    )
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    name="Country"
                                                    data-field-name="country"
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                    defaultValue={userData.Country}
                                                />
                                                {this.errCountryText !== '' && (
                                                    <div className="small form-control-feedback">
                                                        {this.errCountryText}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div className="p-2 d-flex justify-content-center">
                                <a
                                    onClick={this.cancelEdit}
                                    className="btn btn-outline-secondary mr-2"
                                >
                                    Cancel
                                </a>
                                <LaddaButton
                                    className="btn btn-primary ml-2"
                                    loading={this.form.pending}
                                    onClick={this.handleSubmit}
                                    disabled={!this.form.canSubmitForm}
                                    data-size={S}
                                    data-style={SLIDE_LEFT}
                                    data-spinner-size={30}
                                    data-spinner-color="#fff"
                                    data-spinner-lines={12}
                                >
                                    Save changes
                                </LaddaButton>
                            </div>
                        </div>
                    </form>
                </div>
            );
        }
    },
);

export default ProfileEdit;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Profile/components/ProfileEdit.js